import Flatten from '@flatten-js/core'

/* eslint-disable no-param-reassign */
/* eslint-disable no-mixed-operators */

const geometry = {
  radToDeg(rad) {
    return (rad * 180) / Math.PI
  },
  degToRad(deg) {
    return (deg * Math.PI) / 180
  },
  transformPoint(point, ...args) {
    const matrix = this.transformMatrix(...args)
    return Flatten.point(point.x, point.y).transform(matrix)
  },
  reverseTransformPoint(point, ...args) {
    const matrix = this.reverseTransformMatrix(...args)
    return Flatten.point(point.x, point.y).transform(matrix)
  },
  transformMatrix(globalCoords, rotation, localCoords) {
    localCoords = localCoords || { w: 100, h: 100 }
    let matrix = new Flatten.Matrix()
    matrix = matrix.translate(globalCoords.x, globalCoords.y)
    matrix = this.rotateMatrix(matrix, rotation, true)
    matrix = matrix.scale(
      globalCoords.w / localCoords.w,
      globalCoords.h / localCoords.h,
    )
    return matrix
  },
  reverseTransformMatrix(globalCoords, rotation, localCoords) {
    localCoords = localCoords || { w: 100, h: 100 }
    let matrix = new Flatten.Matrix()
    matrix = matrix.scale(
      localCoords.w / globalCoords.w,
      localCoords.h / globalCoords.h,
    )
    matrix = this.rotateMatrix(matrix, rotation, false)
    matrix = matrix.translate(-globalCoords.x, -globalCoords.y)
    return matrix
  },
  rotateMatrix(matrix, rotation, reverse) {
    if (rotation) {
      if (rotation.anchor) {
        matrix = matrix.translate(rotation.anchor.x, rotation.anchor.y)
      }
      const angle = reverse
        ? -this.degToRad(rotation.angle)
        : this.degToRad(rotation.angle)
      matrix = matrix.rotate(angle)
      if (rotation.anchor) {
        matrix = matrix.translate(-rotation.anchor.x, -rotation.anchor.y)
      }
    }
    return matrix
  },
  rotateLayer(matrix, localRotation) {
    const rotation = { anchor: { x: 50, y: 50 }, ...localRotation }
    return this.rotateMatrix(matrix, rotation)
  },
  isPointInCoords(point, coords) {
    coords = coords || {
      x: 0,
      y: 0,
      h: 100,
      w: 100
    }
    return (
      coords.x <= point.x
      && coords.y <= point.y
      && coords.x + coords.w >= point.x
      && coords.y + coords.h >= point.y
    )
  },
  boundingPolygon(coords, ...args) {
    const matrix = this.transformMatrix(...args)
    const points = [
      Flatten.point(coords.x, coords.y),
      Flatten.point(coords.x, coords.y + coords.h),
      Flatten.point(coords.x + coords.w, coords.y + coords.h),
      Flatten.point(coords.x + coords.w, coords.y)
    ]
    let polygon = new Flatten.Polygon()
    polygon.addFace(points)
    polygon = polygon.transform(matrix)
    return polygon
  },
  scaleCoords(coords, scale) {
    scale = scale || 1
    const {
      x, y, w, h
    } = coords
    return {
      x: x - (w * (scale - 1)) / 2,
      y: y - (h * (scale - 1)) / 2,
      w: w * scale,
      h: h * scale
    }
  },
  localGuides() {
    return [
      {
        x: 0, y: 0, w: 10, h: 10
      },
      {
        x: 95, y: 0, w: 10, h: 10
      },
      {
        x: 0, y: 95, w: 10, h: 10
      },
      {
        x: 95, y: 95, w: 10, h: 10
      }
    ]
  },
  getCenter(coords) {
    return {
      x: coords.x + coords.w / 2,
      y: coords.y + coords.h / 2
    }
  },
  getGuides(item) {
    return this.localGuides().map((guide) => ({
      ...guide,
      ...this.transformPoint(guide, item.coords, item.rotation)
    }))
  }
}

export default geometry
